import React, { useRef } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { useTranslation } from 'react-i18next';
import { Modal, Spinner } from 'components';
import { PoHeaderExtract } from './po-header-extract';
import {
  ModalCancelButton,
  ModalConfirmButton,
  ModalCloseButton,
  successModalPaperProps
} from './delivery-modal-actions';

const Label = styled.span`
  color: #1e293b;
  font-size: ${rem('16px')};
`;

export interface ConfirmModalProps {
  visible: boolean;
  success: boolean;
  onConfirm(): void;
  onClose(): void;
  extract: any;
  loading: boolean;
}

export function ConfirmModal({
  visible,
  onClose,
  onConfirm,
  extract,
  loading,
  success
}: ConfirmModalProps) {
  const { t } = useTranslation();
  const successPoRef = useRef(extract?.[0]?.value);
  const poValue = extract?.[0]?.value;

  if (poValue && poValue !== '#undefined') {
    successPoRef.current = poValue;
  }

  const SuccessContent = () => (
    <Label>{t('summary:modals.confirm.success.message', { po: successPoRef.current })}</Label>
  );

  const SuccessActions = () => (
    <ModalCloseButton colorName={{}} onClick={onClose}>
      {t('summary:modals.close_button')}
    </ModalCloseButton>
  );

  const MainContent = () => <PoHeaderExtract extract={extract} />;

  const MainActions = () => (
    <>
      <ModalCancelButton colorName={{}} onClick={onClose}>
        {t('summary:modals.cancel_button')}
      </ModalCancelButton>
      <ModalConfirmButton colorName={{}} onClick={onConfirm}>
        {t('summary:modals.confirm.button')}
      </ModalConfirmButton>
    </>
  );

  return (
    <Modal
      fullWidth
      maxWidth="md"
      open={visible}
      onClose={onClose}
      loading={loading}
      LoadingComponent={<Spinner label={t('summary:modals.confirm.loading_message')} />}
      PaperProps={success ? successModalPaperProps : undefined}
    >
      <Modal.Title>{t('summary:modals.confirm.title')}</Modal.Title>
      <Modal.Content>{success ? <SuccessContent /> : <MainContent />}</Modal.Content>
      <Modal.Actions>{success ? <SuccessActions /> : <MainActions />}</Modal.Actions>
    </Modal>
  );
}
